import { useQuery } from '@tanstack/react-query';
import * as teamService from '../lib/api/teamService';

export const useTeam = (teamId?: string) => {
  const { data: team, isLoading, error } = useQuery({
    queryKey: ['teams', teamId],
    queryFn: () => teamId ? teamService.getTeam(teamId) : null,
    enabled: !!teamId,
  });

  return {
    team,
    isLoading,
    error
  };
}; 